import React from "react";
import { Alert, Button, Glyphicon } from "react-bootstrap";
import { connect } from "react-redux";
import { stopImpersonating } from "../actions/auth";
import { push } from "react-router-redux";
import { impersonatedPartner, role } from "../selectors/auth";
import { PARTNER_ADMIN } from "../selectors/auth";

export default connect(
  (state, ownProps) => ({
    impersonatedPartner: impersonatedPartner(state),
    role: role(state),
  }),
  (dispatch, ownProps) => ({
    stopImpersonating: () => {
      dispatch(stopImpersonating());
      dispatch(push("/"));
    },
  }),
)(({ impersonatedPartner, stopImpersonating, role }) => {
  if (!impersonatedPartner) {
    return null;
  }
  const style = { minHeight: "66px" };
  const queues = impersonatedPartner.queues.join(" ");
  const formattedQueues =
    impersonatedPartner.queues.length === 1
      ? `queue: ${queues}`
      : ` queues: ${queues}`;
  const impersonationMessage =
    role === PARTNER_ADMIN ? (
      <span id="impersonate-context">
        {" "}
        You are impersonating {impersonatedPartner.name}.
      </span>
    ) : (
      <span id="impersonate-context">
        {" "}
        You are viewing data for {formattedQueues}.
      </span>
    );
  return (
    <Alert bsStyle="danger" style={style}>
      <div>
        {impersonationMessage}
        <Button
          id="stop-impersonating"
          className="pull-right btn-primary"
          onClick={stopImpersonating}
        >
          <Glyphicon glyph="glyphicon glyphicon-log-out" /> Stop
        </Button>
      </div>
    </Alert>
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/ImpersonationContext.js